var data = {
	"body": "<path fill=\"currentColor\" d=\"M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm-3 10H9a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
